import type { ReactNode } from 'react';

interface StatCalloutProps {
  highlight: ReactNode;
  detail?: ReactNode;
  icon?: ReactNode;
}

export function StatCallout({ highlight, detail, icon }: StatCalloutProps) {
  return (
    <div className="mt-[26px] flex w-[490px] max-w-full items-start gap-4 py-[6px] font-sans text-base font-medium leading-5 text-soft-black sm:items-center">
      {icon && (
        <div
          aria-hidden="true"
          className="flex h-[44px] w-[31px] shrink-0 items-center justify-center [&_img]:h-full [&_img]:w-full [&_img]:object-contain">
          {icon}
        </div>
      )}
      <div className="min-w-0 flex-1">
        <p className="text-fern">{highlight}</p>
        {detail && <p>{detail}</p>}
      </div>
    </div>
  );
}
